export default __webpack_public_path__ + "static/media/design-illustration.e6d242ce.svg";